export default __webpack_public_path__ + "static/s1-868091b3feaf20f448ab14b5ddba7221.jpg";